import { render, staticRenderFns } from "./open-miniprogram.vue?vue&type=template&id=57b78280&scoped=true&"
import script from "./open-miniprogram.vue?vue&type=script&lang=js&"
export * from "./open-miniprogram.vue?vue&type=script&lang=js&"
import style0 from "./open-miniprogram.vue?vue&type=style&index=0&id=57b78280&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b78280",
  null
  
)

export default component.exports